import { useEffect } from 'react';
import { useAuth } from '@/context/AuthContext';
import { pendingRequestCount } from '@/lib/requestActivity';

// The static screen paints before React. Release it after authentication and
// the first page's requests settle; subsequent navigation never shows it again.
export function StaffStartup() {
    const { checking } = useAuth();
    useEffect(() => {
        const screen = document.getElementById('pout-startup');
        if (!screen) return undefined;
        let quiet;
        const release = () => {
            screen.classList.add('pout-startup-leaving');
            window.setTimeout(() => screen.remove(), 250);
        };
        const check = () => {
            clearTimeout(quiet);
            if (!checking && pendingRequestCount() === 0) quiet = setTimeout(release, 250);
        };
        window.addEventListener('pout-request-count', check);
        check();
        return () => { clearTimeout(quiet); window.removeEventListener('pout-request-count', check); };
    }, [checking]);
    return null;
}
